import { AlpineComponent } from '@alpinejs/csp';

const ContentBlocks = (): AlpineComponent => ({
  visible: false,
  handleIntersect() {
    this.visible = true;
  },
  getClassName() {
    return this.visible ? 'content-blocks--visible' : '';
  }
});

export default ContentBlocks;
